import Vue from 'vue';
import Router from 'vue-router';
import wrap from '../pages/wrap/index.vue';
import * as appUtils from './../core/appUtils';
import {ConstStatic} from './../core/constStatic';
import config from '../core/config';
import {HttpServer} from '../core/http.server';
import {apis} from '../core/apis';

Vue.use(Router);

function loadView(view) {
  return () => import(`../pages${view}.vue`);
}

const router = new Router({
  mode: 'history',
  base: 'ts',
  routes: [
    {
      path: '/',
      redirect: '/home',
      name: 'wrap',
      component: wrap,
      beforeEnter: function (to, from, next) {
        if (to.query.resCode&&to.query.resCode==='logout'){
          localStorage.clear();
          window.location = to.path;
        }
        let projectId = to.query.projectId || '';
        if (projectId) {
          appUtils.setLocalStorage(ConstStatic.PROJECTID, projectId);
        }
        HttpServer.post(apis.api.login.getAPPInfo, {
          where: {
            domain_like:window.location.host
            // domain_like: 'shxy.ts.dev.gdteacher.com'
          }
        }, false, false).then(res => {
          if (res.data && res.data.length > 0) {
            let data = res.data[0];
            config.headerLogo.src = data.topLogoPath;
            config.headerTop.name = data.topTitle;
            config.headerTop.href = data.cmsDomain;
            config.headerTop.hotTel = data.kefuPhone;
            config.footerInfo = data.loginFooter;
            config.hotTel = data.kefuPhone;
            config.appName = data.appName;
            apis.api.studySpace = window.location.origin+'/person/home';
            apis.api.managerUrl = data.lmsDomain;
            apis.api.domainUrl = data.domain.split(',')[0];
            if (!appUtils.getAppId()){
              appUtils.setLocalStorage(ConstStatic.USER_INFO, {'x_appIds':data.appId});
            }
          }
          next();
        }).catch(err => {
          console.log(err);
          next();
        });
      },
      children: [
        {
          path:'/home',
          name:'home',
          component:loadView('/home/home')
        },
        {
          path: '/square',
          name: 'square',
          component: loadView('/square/index')
        },
        {
          path: '/square/newsDetail',
          name: 'newsDetail',
          component: loadView('/square/newsDetail')
        },
        {
          path: '/resourceCenter',
          name: 'resourceCenter',
          component: loadView('/resourceCenter/index')
        },
        {
          path: '/resourceCenter/detailiframe',
          name: 'detailiframe',
          component: loadView('/resourceCenter/detailiframe')
        },
        {
          path: '/community',
          name: 'community',
          component: loadView('/community/index')
        },
        {
          path: '/community/detailiframe',
          name: 'detailiframe',
          component: loadView('/community/detailiframe')
        },
        {
          path: '/community/detail',
          name: 'detail',
          component: loadView('/community/detail')
        },
        {
          path: '/trainStatistics',
          name: 'trainStatistics',
          component: loadView('/home/trainStatistics/index')
        },
        {
          path: '/policyList',
          name: 'policyList',
          component: loadView('/home/policyList/policyList')
        },
        {
          path: '/policyList/policyDetail',
          name: 'policyDetail',
          component: loadView('/home/policyList/policyDetail')
        },
        {
          name: 'consultCourse',
          path: '/consultCourse',
          component: loadView('/consultCourse/index')
        },
        {
          path: '/FJConsultCourse',
          component: loadView('/consultCourse/FJConsultCourse')
        },
        {
          path: '/showSpecialGreen',
          component: loadView('/consultCourse/showSpecialRed')
        },
        {
          path: '/showSpecialRed',
          component: loadView('/consultCourse/showSpecialRed')
        },
        {
          path: '/noSpecial',
          component: loadView('/consultCourse/noSpecial')
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0};
  }

});
export default router;
const defaultTitle = '项目主站';
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title : defaultTitle;
  next();
});



// WEBPACK FOOTER //
// ./src/router/index.js